import {
    createApp
} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Toast, {
    POSITION,
    TYPE
} from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'animate.css';


const options = {
    position: POSITION.BOTTOM_RIGHT,
    toastDefaults: {
        [TYPE.ERROR]: {
            timeout: 5000,
            hideProgressBar: true,
        },
        [TYPE.INFO]: {
            timeout: false,
            hideProgressBar: true,
        },
        [TYPE.SUCCESS]: {
            timeout: 3000,
            hideProgressBar: true,
        },
    },
};
const app = createApp(App)
app.use(VueSweetalert2);
app.use(store)
app.use(Toast, options)
app.use(router)
app.mount('#app');